import Profile from './Profile';
import ChangePassword from './ChangePassword';

export {
  Profile,
  ChangePassword
}


// WEBPACK FOOTER //
// ./src/containers/Me/index.js